import { Injectable } from '@angular/core';
import { IDataService, Data, DataNode } from '../shared/types';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export abstract class DataService implements IDataService<Data> {
    abstract getContent(data: Data): Observable<{ files: Data[]; dirs: Data[] }>;
    abstract viewFile(data: Data): Observable<Data>;
    abstract sendFile(data: Data): Observable<Data>;
    abstract editFile(data: Data): Observable<Data>;
    abstract createDir(data: Data, name: string): Observable<Data>;
    abstract rename(data: Data, newName: string): Observable<Data>;
    abstract moveitem(data: Data, parentId: number): Observable<Data>;
    abstract delete(data: Data[]): Observable<Data>;
    abstract uploadFiles(data: Data, files: FileList): Observable<Data>;
    abstract downloadFile(data: Data): Observable<Data>;
    abstract getName(data: Data): string;
    abstract openTree(data: Data): Observable<Array<DataNode<Data>>>;

    /** Invia (o reinvia) il documento in analisi verso il RAG */
    abstract sendToRag(data: Data): Observable<Data>;
    /** Rimuove il documento dalla conoscenza del RAG */
    abstract removeFromRag(data: Data): Observable<Data>;
}
